import { Map } from "immutable";

export default {
  showVesselDetail: false,
  showPlotDetail: false,
  showPrivatePlotDetail: false,
  unsubscribes: [],
  vesselDetail: null,
  plotDetail: null,
  privatePlotDetail: null,
  monitoringState: false,
  vesselPictures: null,
  vesselCameras: [],
  vesselRadars: [],
  vesselDetailInfo: null,
  vesselDetailPosition: null,
  countryCodes: [],
  ownVessels: [],
  ownVesselPosition: Map(),
  ownVesselPointFeatureCollection: [],
  ownVesselPolygonFeatureCollection: [],
  ownVesselVectorFeatureCollection: [],
  ownVesselDisplayDurationTime: 0,
  monitoringVessels: [],
  selectedVesselPosition: Map(),
  selectedVesselPointFeatureCollection: [],
  selectedVesselPolygonFeatureCollection: [],
  selectedVesselVectorFeatureCollection: [],
  isNewSelectedVessel: false,
  metoceanInitialDatetime: null,
  oldWeatherSourceLayerId: null,
  currentWeatherSourceLayerId: null,
  weatherCurrentDatetime: null,
  selectedMetoceanElement: null,
  showWeatherMenu: false,
  showContour: false,
  showMetoceanValue: true,
  showMetoceanGrid: true,
  isTimeSyncMode: false,
  updateMetoceanSourceLayer: null,
  updateContourSourceLayer: null,
  activeLayersSidebar: false,
  activeSearchSidebar: false,
  activeOwnVesselSidebar: false,
  activeSelectVesselSidebar: false,
  activeFilterSidebar: false,
  activePlotSidebar: false,
  activePrivatePlotSidebar: false,
  activeWeatherSidebar: false,
  activeVehicleSidebar: false,
  activeVesselEquipmentBaseStationSidebar: false,
  activeSettingsSidebar: false,
  activeAnchorVesselSidebar: false,
  // 船舶のラストポジションリストを格納
  lastVesselPositions: [],

  offingWavePoints: [],
  dialogOffingWavePointInputForm: null,
  offingWavePointInputValues: null,
  typhoonInfoList: null,
  typhoonLayerVisibility: true,
  selectedVehicle: null,
  jumpTo: null,
  jumpToMap: null,
  mapStyle: null,
  searchResult: {
    vessel: {
      key: "name",
      data: [],
    },
  },
  wakes: Map(),
  oldestVesselId: null,
  wakeLineFeatureCollection: [],
  filterVessels: [],
  filterPlots: [],
  filterPrivatePlots: [],
  filterNavigations: [],
  filterRadarGrid: [],
  favoriteList: [
    {
      groupList: [],
      label: null,
    },
    {
      groupList: [],
      label: null,
    },
    {
      groupList: [],
      label: null,
    },
  ],
  groupUnsubscribes: [],
  selectedFixedPointCamera: null,
};
